module.exports = ".goTop {\n  cursor: pointer;\n  position: fixed;\n  bottom: 120px;\n  right: 30px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/cms/cms.component.scss
// module id = ./src/app/cms/cms.component.scss
// module chunks = main